export const POKey = {
    HEADLINE_LOOKS_INFUSION: 'PDP_Look_Infusion_Headline',
    CTA_LOOKS_INFUSION: 'Shop the look',
    LAST_TILE_HEADLINE_LOOKS_INFUSION: 'PDP_Look_Infusion_See Look',
    LAST_TILE_CTA_LOOKS_INFUSION: 'Shop the look',
};

export const DEFAULT_SKELETON_SIZE = 8;
